export function getOppositeDirection(input="") {
  if (input === "UP") { return "DOWN"}
  if (input === "RIGHT") { return "LEFT"}
  if (input === "LEFT") { return "RIGHT"}
  return "UP"
}